import { extendTheme } from '@chakra-ui/react';

// --- Paleta da marca Punara ---
// Cores da marca
//   #66CAD7  teal claro (primary 300)
//   #1B88A2  teal escuro (primary 500 — cor principal)
//   #445351  cinza escuro (neutro para texto)
// Cores secundárias
//   #1A2B3C  Azul Marinho Profundo
//   #00C897  Verde Sucesso
//   #FF8C42  Laranja Alerta
//   #F4F7F9  Cinza Soft Interface
//   #6C5CE7  Roxo Dashboard
//   #E1F5FE  Azul Gelo Destaque

const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },

  colors: {
    brand: {
      50: '#e8f7fa',
      100: '#c4eaf1',
      200: '#9ddce7',
      300: '#66CAD7',
      400: '#3db8cc',
      500: '#1B88A2',
      600: '#167690',
      700: '#10607a',
      800: '#0b4a60',
      900: '#063040',
    },
    navy: {
      50: '#e8edf2',
      100: '#c5cfdc',
      200: '#9fb0c4',
      300: '#7891ac',
      400: '#4e6d8a',
      500: '#1A2B3C',
      600: '#162535',
      700: '#111c28',
      800: '#0c141c',
      900: '#060a0e',
    },
    success: {
      50: '#e0faf4',
      100: '#b3f3e3',
      200: '#80ebd0',
      300: '#4de2bc',
      400: '#26daab',
      500: '#00C897',
      600: '#00b386',
      700: '#009972',
      800: '#007f5d',
      900: '#005c43',
    },
    alert: {
      50: '#fff3eb',
      100: '#ffdfc7',
      200: '#ffc9a0',
      300: '#ffb378',
      400: '#ff9f5c',
      500: '#FF8C42',
      600: '#e67a38',
      700: '#cc6a2d',
      800: '#b35923',
      900: '#804018',
    },
    softGray: {
      50: '#ffffff',
      100: '#fafbfc',
      200: '#f8f9fb',
      300: '#f6f8fa',
      400: '#f5f7f9',
      500: '#F4F7F9',
      600: '#d8dfe5',
      700: '#b0bcc6',
      800: '#8898a7',
      900: '#607588',
    },
    dashboard: {
      50: '#f0eeff',
      100: '#d8d4fb',
      200: '#bdb8f7',
      300: '#a19cf3',
      400: '#877fed',
      500: '#6C5CE7',
      600: '#5c4ed0',
      700: '#4c3fb6',
      800: '#3c319b',
      900: '#2b2270',
    },
    iceBlue: {
      50: '#f9fdff',
      100: '#f0faff',
      200: '#e8f7fe',
      300: '#e5f6fe',
      400: '#e3f5fe',
      500: '#E1F5FE',
      600: '#b3dff8',
      700: '#7ec8f1',
      800: '#49b0eb',
      900: '#1a95df',
    },
    brandNeutral: {
      50: '#edf1f0',
      100: '#d0dbd9',
      200: '#b1c3c1',
      300: '#91aca9',
      400: '#6f9290',
      500: '#445351',
      600: '#3b4947',
      700: '#2f3a39',
      800: '#242c2b',
      900: '#141a19',
    },
  },

  fonts: {
    heading: "'Archivo', sans-serif",
    body: "'Lato', sans-serif",
  },

  components: {
    Heading: {
      baseStyle: {
        color: 'brand.500',
      },
    },
    Switch: {
      defaultProps: {
        colorScheme: 'brand',
      },
    },
    IconButton: {
      defaultProps: {
        colorScheme: 'brand',
      },
    },
    Button: {
      baseStyle: {
        fontWeight: 'bold',
        borderRadius: 'md',
      },
      defaultProps: {
        colorScheme: 'brand',
      },
    },
  },
});

export default theme;
